import { Chip, Typography } from '@mui/material'
import { useMemo } from 'react'

import { Maybe, PreSaleStatus } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

type PreSaleStatusTagProps = {
  status: Maybe<PreSaleStatus> | undefined
}
export const PreSaleStatusTag: Cell<PreSaleStatusTagProps> = ({ status }) => {
  const { t } = useTranslation('lotteryDetail')

  const bgcolor = useMemo(() => {
    switch (status) {
      case PreSaleStatus.Accepting:
        return 'primary.main'
      case PreSaleStatus.BeforeReceiption:
        return 'secondary.main'
      case PreSaleStatus.SoldOut:
        return 'error.main'
      default:
        return 'grey.300'
    }
  }, [status])

  if (!status) return null

  return (
    <Chip
      label={
        <Typography variant="overline" color="white">
          {t(status)}
        </Typography>
      }
      sx={{
        p: 0,
        bgcolor,
        height: 20,
        '.MuiChip-label': { p: 1 },
      }}
    />
  )
}
